import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import {Col, Row} from '../../../shared/packages/Grid';
import {navRoolz} from './navHelpers';
import LeftNavButton from './LeftNavButton.jsx';
import CenterNavButton from './CenterNavButton.jsx';
import _ from 'lodash';

class Nav extends Component {
  render() {
    const {
      showCancelButton,
      backNavDestination,
    } = this.props;

    const showLeftNavButton = backNavDestination || showCancelButton;

    return (
      <div role="banner" className="polaris-rwd" data-dtm="container" data-dtm-level1="header" id="polaris-nav-header-wrapper">
        <div aria-label="Main Navigation" className="polaris-recognized" data-click-track-placement="GlobalHeader" id="polaris-header" role="navigation">
          <div className="polaris-nav container" data-track-module="header" data-track-type="basic">
            <Row>
              <Col xs={12}>
                <Row className="flex-align-center">
                  {showLeftNavButton &&
                    <Col xs={4} className="polaris-xfinity-back-container text-left">
                      <LeftNavButton {...this.props} />
                    </Col>
                  }
                  <Col xs={showLeftNavButton ? 4 : 12} className="text-center">
                    <CenterNavButton />
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }
}

Nav.propTypes = {
  showCancelButton: PropTypes.bool.isRequired,
  backNavDestination: PropTypes.string
};

function mapStateToProps(state) {
  const {
    showCancelButton,
    backNavText,
    backNavDestination,
    backNavIsExternalDestination
  } = navRoolz(state);

  return {
    salesSessionId: _.get(state, 'common.salesSessionId', ''),
    showCancelButton,
    backNavText,
    backNavDestination,
    backNavIsExternalDestination
  };
}

export default connect(
  mapStateToProps
)(Nav);



/** WEBPACK FOOTER **
 ** ./client/components/Common/Nav/Nav.jsx
 **/